import { render, staticRenderFns } from "./mlact.vue?vue&type=template&id=5463b2ac&scoped=true&"
import script from "./mlact.vue?vue&type=script&lang=js&"
export * from "./mlact.vue?vue&type=script&lang=js&"
import style0 from "./mlact.vue?vue&type=style&index=0&id=5463b2ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5463b2ac",
  null
  
)

export default component.exports